<template>
  <v-hover
    v-slot="{ hover }"
    open-delay="200"
    close-delay="200"
  >
  <a
    :href="productHref || undefined"
    class="product-card-link"
    :aria-disabled="tiendaCerrada || esAgotado ? 'true' : undefined"
    @click.prevent="viewProduct"
  >
  <v-card
    :elevation="hover && !esAgotado ? 4 : 0"
    :class="{ 'on-hover': hover && !esAgotado, 'product-card--agotado': esAgotado }"
    class="product-card"
    outlined
  >
    <div v-if="product.esMasVendido && !esAgotado" class="best-seller px-4 pt-3">
      <v-icon small color="teal">mdi-star</v-icon>
      <span>Más vendido</span>
    </div>
    <template v-if="!hasNoImage">
      <div class="image-wrap">
        <v-img
          :src="product.detalle.srcImg"
          :alt="product.nombre"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.05), rgba(0,0,0,.35)"
          height="180px"
        >
          <v-card-title v-text="product.nombre"></v-card-title>
        </v-img>
      </div>
    </template>
    <template v-else>
      <v-card-title class="product-name-no-img-alt" v-text="product.nombre"></v-card-title>
    </template>
    <v-card-text class="product-body">
      <div v-if="descuento !== product.precio" class="price-block">
        <span class="price-discount">$ {{ descuento }}&nbsp;</span>
        <del class="price-original">${{ product.precio }}</del>
      </div>
      <div v-else class="price-block">
        <span class="price">$ {{ product.precio }}</span>
      </div>
      <p v-if="product.descripcion" class="mt-2 mb-0">{{ product.descripcion }}</p>
      <div class="status-slot">
        <v-chip
          v-if="esAgotado"
          small
          label
          color="error"
          dark
        >Agotado</v-chip>
      </div>
    </v-card-text>
  </v-card>
  </a>
  </v-hover>
</template>
<script>
import { mapGetters } from 'vuex'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import { isProductoAgotado } from '@/helpers/productoAgotado.js'
import { productPath } from '@/helpers/seoUrls.js'

export default {
  name: 'CategoriaProductCard',
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('App', ['tiendaCerrada']),
    productHref () {
      if (!this.product) return null
      return productPath(this.$clientCode(), this.product.id)
    },
    esAgotado () {
      return isProductoAgotado(this.product)
    },
    descuento () {
      return descuentoHelper.precioConDescuento(this.product)
    },
    hasNoImage () {
      return this.product && this.product.detalle && this.product.detalle.srcImg && this.product.detalle.srcImg.includes('noimage_Producto.png')
    }
  },
  methods: {
    viewProduct () {
      if (this.tiendaCerrada || this.esAgotado) return
      const code = this.$clientCode()
      this.$router.push({
        name: 'Producto',
        params: {
          client: code,
          id: this.product.id
        }
      })
    }
  }
}
</script>
<style scoped>
.product-card-link {
  display: block;
  height: 100%;
  color: inherit;
  text-decoration: none;
}
.v-card__text, .v-card__title {
  word-break: normal;
}
.product-card {
  cursor: pointer;
  border-radius: 12px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.product-card--agotado {
  cursor: default;
  opacity: 0.85;
}
.product-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.price-block {
  min-height: 1.5rem;
}
.status-slot {
  margin-top: 8px;
  min-height: 28px;
  display: flex;
  align-items: center;
}
.best-seller {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #00897b;
  font-size: 0.8rem;
  font-weight: 600;
}
.price,
.price-discount {
  font-weight: 700;
  font-size: 1.25rem;
}
.price-original {
  color: rgba(0, 0, 0, 0.45);
}
.product-name-no-img-alt {
  text-align: center;
  padding: 16px;
  word-break: normal;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}
</style>
